import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Ui.css';

function Navbar({ onToggle }) {
  const navigate = useNavigate();
  const [isCollectingStats, setIsCollectingStats] = useState(false);

  const handleCollectStats = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      alert('로그인이 필요합니다.');
      return;
    }

    try {
      setIsCollectingStats(true);
      const response = await axios.post(
        '/api/stats/collect/now',
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const totalCompanies = Number(response?.data?.totalCompanies || 0);
      alert(`통계 수집이 완료되었습니다. 처리 회사 수: ${totalCompanies}`);
    } catch (error) {
      const message = error?.response?.data?.message || '통계 수집 중 오류가 발생했습니다.';
      alert(message);
    } finally {
      setIsCollectingStats(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('session');
    navigate('/login');
  };

  return (
    <nav className="topbar d-flex align-items-center justify-content-between px-3 py-2 shadow-sm">
      <div className="d-flex align-items-center">
        <button className="btn btn-outline-secondary me-3" onClick={onToggle}>
          <i className="fas fa-bars"></i>
        </button>
      </div>

      <div className="d-flex align-items-center">
        <button
          className="btn btn-outline-primary me-2"
          onClick={handleCollectStats}
          title="통계 수집"
          disabled={isCollectingStats}
        >
          <i className="fas fa-database"></i>
        </button>
        <button
          className="btn btn-outline-danger"
          onClick={handleLogout}
          title="로그아웃"
        >
          <i className="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;